// TReachHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import TReachAbout from "./TReachAbout";

const tabs = [
  { id: "about", label: "💭 About", tagline: "Vision, Mission, Roles & FAQ!" },
  { id: "atl", label: "📺 ATL", tagline: "Reach the masses and build your brand!" },
  { id: "btl", label: "🎯 BTL", tagline: "Engage directly, measure precisely!" },
  { id: "ttl", label: "🔄 TTL", tagline: "Combine the best of both ATL & BTL worlds!" },
];

const useCases = {
  atl: [
    { label: "📺 TV Ads", id: "tv-ads" },
    { label: "💻 Online Ads", id: "online-ads" },
    { label: "📰 Print/Billboards", id: "print-billboards" },
  ],
  btl: [
    { label: "🎪 Events", id: "events" },
    { label: "🛍️ Product Demos", id: "product-demos" },
    { label: "✉️ Direct Mail", id: "direct-mail" },
  ],
  ttl: [
    { label: "🔗 Integrated Campaigns", id: "integrated" },
    { label: "🚀 Multi-channel Launch", id: "multi-channel" },
    { label: "🌐 Social + Offline", id: "social-offline" },
  ],
};

const sectionIds = [
  { id: "campaigns", label: "Campaigns 🗂️" },
  { id: "operations", label: "Operations 🛠️" },
  { id: "feedback", label: "Customer Feedback 💬" },
  { id: "logs", label: "Logs 📜" },
  { id: "reports", label: "Reports & Analytics 📊" },
];

const TReachHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("atl");
  const [selectedUseCase, setSelectedUseCase] = useState(null);
  const [activeSection, setActiveSection] = useState("campaigns");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const renderSectionContent = () => {
    if (!selectedUseCase) return null;

    switch (activeSection) {
      case "campaigns":
        return (
          <div className="mt-3 text-sm text-gray-200 space-y-2">
            <p>📂 <strong>Dummy Campaign Overview</strong> for {selectedUseCase.label}</p>
            <ul className="list-disc list-inside text-gray-300">
              <li>Objective: Brand awareness in Tier-1 cities</li>
              <li>Duration: 4 weeks</li>
              <li>Budget: ₹2,50,000</li>
              <li>Status: 🟢 Active</li>
            </ul>
          </div>
        );
      case "operations":
        return (
          <div className="mt-3 text-sm text-gray-200 space-y-2">
            <p>🛠️ <strong>Operations Tasks</strong></p>
            <ul className="list-disc list-inside text-gray-300">
              <li>Finalize creatives by Design Team – ✅</li>
              <li>Confirm slots with media vendors – ⏳</li>
              <li>Share tracking links with client – ⏳</li>
            </ul>
          </div>
        );
      case "feedback":
        return (
          <div className="mt-3 text-sm text-gray-200 space-y-2">
            <p>💬 <strong>Sample Customer Feedback</strong></p>
            <ul className="list-disc list-inside text-gray-300">
              <li>“Saw your ad on TV, loved the concept!” 😀</li>
              <li>“The offer wasn’t clear in the print ad.” 😕</li>
              <li>NPS (dummy): 7.8 / 10</li>
            </ul>
          </div>
        );
      case "logs":
        return (
          <div className="mt-3 text-sm text-gray-200 space-y-2">
            <p>📜 <strong>Activity Logs (Dummy)</strong></p>
            <ul className="list-disc list-inside text-gray-300">
              <li>2025-12-01 10:15 – Campaign created</li>
              <li>2025-12-02 14:30 – Creatives uploaded</li>
              <li>2025-12-03 09:00 – Media plan approved</li>
            </ul>
            <p className="text-xs text-gray-400 mt-1">
              Export options: JSON 📤 | CSV 📤 (to be wired with backend later)
            </p>
          </div>
        );
      case "reports":
        return (
          <div className="mt-3 text-sm text-gray-200 space-y-2">
            <p>📊 <strong>Reports & Analytics (Dummy)</strong></p>
            <ul className="list-disc list-inside text-gray-300">
              <li>Impressions: 1,200,000 👁️</li>
              <li>Engagement Rate: 4.5% 📈</li>
              <li>Estimated Conversions: 3,200 💵</li>
            </ul>
            <p className="text-xs text-gray-400 mt-1">
              [Graph placeholder: Reach vs Engagement vs Conversions]
            </p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-teal-300">📣 TransformReach</div>
          <div className="text-[11px] text-gray-200">
            Boutique ATL, BTL, TTL Operations at Your Fingertips!
          </div>
          <div className="text-[11px] text-yellow-200">
            From Strategy to Execution, All-in-One
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-4 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
            >
              Login
            </button>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-red-600 hover:bg-red-700"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      <div className="grid grid-cols-4 border-b border-gray-700 place-items-center py-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`text-xs lg:text-m py-2 px-4 font-medium ${
              activeTab === tab.id ? "border-b-2 border-green-400" : "text-gray-500"
            }`}
            onClick={() => {
              setActiveTab(tab.id);
              setSelectedUseCase(null);
              setActiveSection("campaigns");
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="p-4 flex-1">
        {activeTab === "about" && <TReachAbout />}
        {activeTab !== "about" && (
          <>
            {!selectedUseCase && (
              <div className="grid grid-cols-3 place-items-center gap-2 mt-1">
                {useCases[activeTab]?.map((uc, idx) => (
                  <button
                    key={idx}
                    className="text-xs lg:text-m py-2 px-2 rounded-md bg-gray-900 hover:bg-gray-800 text-white font-semibold shadow-md w-full text-center"
                    onClick={() => navigate(`/treach/${activeTab}/${uc.id}/campaigns`)}
                  >
                    {uc.label}
                  </button>
                ))}
              </div>
            )}

            {selectedUseCase && (
              <div className="mt-4">
                <div className="text-center text-lg font-bold text-teal-300 mb-1">
                  {selectedUseCase.label}
                </div>
                <div className="mt-2 grid grid-cols-5 gap-2 place-items-center">
                  {sectionIds.map((sec) => (
                    <button
                      key={sec.id}
                      className={`px-3 py-1 rounded-sm text-xs border ${
                        activeSection === sec.id
                          ? "bg-teal-500 text-black border-teal-400"
                          : "bg-gray-800 text-gray-200 border-gray-700"
                      }`}
                      onClick={() => setActiveSection(sec.id)}
                    >
                      {sec.label}
                    </button>
                  ))}
                </div>

                {renderSectionContent()}
                <button
                  onClick={() => navigate(selectedUseCase.route)}
                  className="mt-5 px-4 py-2 bg-blue-700 hover:bg-blue-800 rounded-lg text-white text-sm"
                >
                  Open Full {selectedUseCase.label} Workspace →
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">
              About
            </Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">
              Terms of Use
            </Link>
            <Link to="/contact-us" className="hover:text-teal-300">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TReachHome;
